export const DECIMAL_SEPARATOR = ",";
export const THOUNSAND_SEPARATOR = ".";
//# sourceMappingURL=constants.js.map